module.exports = __webpack_public_path__ + "static/media/C5.33f7da22.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/C5.png
// module id = 897
// module chunks = 0